<template>
  <div class="formGroup">
    <div class="item">
      <Form
        v-if="formDate.length > 0"
        v-for="(item1, index) in formDate"
        :label-width="item1.labelWidth ? item1.labelWidth : 100"
        :label-colon="false"
        class="formInfo"
        :class="{
          'hidden': item1.hidden === true,
        }"
        :label-position="!item1.position ? 'right' : item1.position"
        :ref="`perForm${index}`"
        :model="item1"
        :key="index"
      >
        <div>
          <div
            class="title"
            v-if="item1.title"
          >
            <div>
              <node-content :current="item1.title" :data="item1.title" />
            </div>
          </div>
          <!-- 非动态表单 -->
          <Row type="flex" justify="start" v-if="!item1.add">
            <template v-for="(item, idx) in item1.data">
              <!-- 自定义render组件 -->
              <Col
                :class="{
                  block: item.block === true || item1.full === true,
                  hidden: item.hidden === true,
                }"
                v-bind="JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }"
                v-if="item.type === -1"
              >
                <FormItem
                  :label="item.name ? item.name + '' : null"
                  :class="[item.className ? item.className : null]"
                  class="formItem"
                  :prop="'data.' + idx + '.value'"
                  :rules="item.rules"
                >
                  <custome-render
                    :render="item.renderLabel"
                    :current="item"
                    slot="label"
                    v-if="item.renderLabel"
                  />
                  <custome-render
                    v-model="
                      item.dealValue ? item.dealValue(item.value) : item.value
                    "
                    :render="item.render"
                    :current="item"
                    v-if="item.render"
                  />
                  <custome-render
                    v-model="item.value"
                    v-if="item.slot"
                    :ref="`customeRender${idx}`"
                  >
                    <slot
                      :name="item.slot"
                      :row="item"
                      :index="idx"
                      :slots="
                        $refs[`customeRender${idx}`]
                          ? $refs[`customeRender${idx}`][0]
                          : null
                      "
                    ></slot>
                  </custome-render>
                </FormItem>
              </Col>
              <Col
                :class="{
                  block: item.block === true || item1.full === true,
                  hidden: item.hidden === true,
                  notShow: item.notShow === true,
                }"
                v-bind="JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }"
                v-if="item.type === 1 && !item.hidden"
              >
                <FormItem
                  :label="item.name ? item.name + '' : ''"
                  class="formItem"
                  :class="[item.className ? item.className : null]"
                  :prop="'data.' + idx + '.value'"
                  :rules="item.rules"
                >
                  <div v-if="item.readonly">
                    <span v-if="!item.render">{{ item.value }}</span>
                    <span v-if="item.txt">{{ item.txt }}</span>
                    <customeRender
                      v-else
                      :render="item.render"
                      :current="item"
                    />
                  </div>
                  <Input
                    :disabled="item.disabled ? true : false"
                    :maxlength="item.maxlength"
                    :show-word-limit="item.showWordLimit"
                    v-else
                    @on-focus="
                      item.onFocus ? item.onFocus(item.value, item) : null
                    "
                    @on-change="
                      item.onChange ? item.onChange(item.value, item) : null
                    "
                    @on-blur="
                      item.onBlur ? item.onBlur(item.value, item) : null
                    "
                    :placeholder="
                      item.placeholder ? item.placeholder : `请输入${item.name}`
                    "
                    :value="
                      item.dealValue ? item.dealValue(item.value) : item.value
                    "
                    @input="($event) => (item.value = $event)"
                    :clearable="true"
                    :type="item.modelType ? item.modelType : 'text'"
                  ></Input>
                  <span v-if="item.afterTxt">{{ item.afterTxt }}</span>
                  <customeRender
                    v-if="item.afterRender"
                    :render="item.afterRender"
                    :current="item"
                  />
                </FormItem>
              </Col>

              <!--下拉框 -->
              <Col
                v-bind="JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }"
                v-if="item.type === 2 && !item.hidden"
                :key="idx"
                :class="{
                  block: item.block === true || item1.full === true,
                  hidden: item.hidden === true,
                }"
              >
                <FormItem
                  :label="item.name + ''"
                  class="formItem"
                  :prop="'data.' + idx + '.value'"
                  :rules="item.rules"
                >
                  <Select
                    v-if="!item.readonly"
                    :transfer="true"
                    :disabled="item.disabled ? true : false"
                    :multiple="item.multiple ? true : false"
                    v-model="item.value"
                    ref="filterableSearchName"
                    :filterable="item.remote || item.filterable ? true : false"
                    :placeholder="`请选择${item.name}`"
                    clearable
                    @on-query-change="
                      (e) => {
                        item.remote && item.queryChange
                          ? item.queryChange(e, item)
                          : null;
                      }
                    "
                    :remote-method="
                      item.remote
                        ? (name) => item.remoteMethod(name, item)
                        : null
                    "
                    :remote="item.remote ? true : false"
                    @on-change="
                      (value) => (item.fn ? item.fn(value, item) : () => {})
                    "
                  >
                    <Option
                      v-for="(v, index) in item.arr"
                      :value="v.value"
                      :key="index"
                      :label="v.label"
                    >
                      <!-- {{ v.label }} -->
                      {{ !v.extra ? v.label : v.label + v.extra }}
                      <!-- <node-content :current="v" :data="item" /> -->
                    </Option>
                  </Select>
                  <div v-if="item.readonly">
                    <span v-if="!item.render">
                      {{ dealValue(item.value, item.arr) }}
                    </span>
                    <span v-if="item.txt">{{ item.txt }}</span>
                    <customeRender
                      v-else
                      :render="item.render"
                      :current="item"
                    />
                  </div>
                </FormItem>
              </Col>
              <!-- 日期选择 -->
              <Col
                v-bind="JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }"
                v-if="item.type === 3"
                :class="{
                  block: item.block === true || item1.full === true,
                  hidden: item.hidden === true,
                  notShow: item.notShow === true,
                }"
              >
                <FormItem
                  :style="{ ...item.style }"
                  v-if="!item.hidden"
                  :label="item.name + ''"
                  class="formItem"
                  :class="[item.className ? item.className : null]"
                  :prop="'data.' + idx + '.value'"
                  :rules="item.rules"
                >
                  <div v-if="item.readonly">
                    <span v-if="!item.render">{{
                      dealTime(item.value, item.filter)
                    }}</span>
                    <span v-if="item.txt">{{ item.txt }}</span>
                    <customeRender
                      v-else
                      :render="item.render"
                      :current="item"
                    />
                  </div>

                  <DatePicker
                    :ref="`myPicker${idx}`"
                    v-else
                    :transfer="true"
                    :options="item.options ? item.options : null"
                    width="100%"
                    :type="item.dateType ? item.dateType : 'date'"
                    :value="item.value"
                    :format="
                      item.dateType != 'month' && !item.format
                        ? 'yyyy-MM-dd'
                        : item.format
                        ? item.format
                        : null
                    "
                    :placeholder="`请选择${item.name}`"
                    :time-picker-options="
                      item.pickerOptions ? item.pickerOptions : null
                    "
                    @on-change="
                      (val) =>
                        item.changeTime
                          ? item.changeTime(
                              val,
                              item,
                              $refs[`myPicker${idx}`][0]
                            )
                          : changeTime(val, item)
                    "
                    @on-open-change="
                      (val) =>
                        item.onOpenChange ? item.onOpenChange(val, item) : null
                    "
                  ></DatePicker>
                </FormItem>
              </Col>
              <!-- 树形结构 -->
              <Col
                v-bind="JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }"
                :class="{
                  block: item.block === true || item1.full === true,
                  hidden: item.hidden === true,
                  notShow: item.notShow === true,
                }"
                v-if="item.type === 4"
              >
                <FormItem
                  :label="item.name + ''"
                  class="formItem selectTree"
                  :prop="'data.' + idx + '.value'"
                  :rules="item.rules"
                >
                  <selectTree
                    :disabled="item.disabled ? true : false"
                    :data="item.arr"
                    :multiple="item.multiple ? item.multiple : false"
                    :size="null"
                    :placeholder="`请选择${item.name}`"
                    :single="true"
                    :selectAllChildren="
                      item.selectAllChildren ? item.selectAllChildren : false
                    "
                    @onChange="
                      item.inputChange
                        ? item.inputChange(item.value, item)
                        : null
                    "
                    v-model="item.value"
                  ></selectTree>
                </FormItem>
              </Col>
              <!--数字类型 -->
              <Col
                v-bind="JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }"
                v-if="item.type === 5"
                :class="{
                  block: item.block === true || item1.full === true,
                  hidden: item.hidden === true,
                  notShow: item.notShow === true,
                }"
              >
                <FormItem
                  :label="item.name + ''"
                  class="formItem"
                  :prop="'data.' + idx + '.value'"
                  :rules="item.rules"
                >
                  <div v-if="item.readonly">
                    <span v-if="!item.render">{{ item.value }}</span>
                  </div>
                  <InputNumber
                    v-else
                    width="100%"
                    :placeholder="`请输入${item.name}`"
                    v-model.trim="item.value"
                  ></InputNumber>
                </FormItem>
              </Col>
              <!--单选radio -->
              <Col
                v-bind="JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }"
                v-if="item.type === 6"
                :class="{
                  block: item.block === true || item1.full === true,
                  hidden: item.hidden === true,
                }"
              >
                <FormItem
                  :label="item.name + ''"
                  class="formItem"
                  :prop="'data.' + idx + '.value'"
                  :rules="item.rules"
                >
                  <RadioGroup
                    v-model="item.value"
                    width="100%"
                    @on-change="
                      item.radioChanges ? item.radioChanges(item.value) : null
                    "
                  >
                    <Radio
                      :disabled="item.disabled ? true : false"
                      :style="{
                        marginRight: i !== item.arr.length - 1 ? '40px' : 0,
                      }"
                      :key="i"
                      :label="v.value"
                      v-for="(v, i) in item.arr"
                      >{{ v.label }}</Radio
                    >
                  </RadioGroup>
                </FormItem>
              </Col>
              <!--多选checkBox -->
              <Col
                v-bind="JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }"
                v-if="item.type === 7"
                :class="{
                  block: item.block === true || item1.full === true,
                  hidden: item.hidden === true,
                }"
              >
                <FormItem
                  :label="item.name + ''"
                  class="formItem"
                  :prop="'data.' + idx + '.value'"
                  :rules="item.rules"
                >
                  <CheckboxGroup v-model="item.value" width="100%">
                    <Checkbox
                      :style="{
                        marginRight: i !== item.arr.length - 1 ? '40px' : 0,
                      }"
                      :key="i"
                      :label="v.value"
                      v-for="(v, i) in item.arr"
                      >{{ v.label }}</Checkbox
                    >
                  </CheckboxGroup>
                </FormItem>
              </Col>
              <!-- 复合类型 select + input -->
              <Col
                v-bind="JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }"
                v-if="item.type === 8"
              >
                <FormItem
                  class="formItem reunite"
                  :prop="'data.' + idx + '.value'"
                  :rules="item.rules"
                >
                  <Input
                    v-model="item.value[1]"
                    clearable
                    :placeholder="item.placeholder ? item.placeholder : ''"
                  >
                    <Select
                      v-model="item.value[0]"
                      slot="prepend"
                      :style="
                        item.width ? 'width:' + item.width : 'width: 80px'
                      "
                      @on-change="item.value[1] = ''"
                      :transfer="true"
                    >
                      <Option
                        :value="its.value"
                        v-for="(its, idx) in item.arr"
                        :key="idx"
                        >{{ its.label }}</Option
                      >
                    </Select>
                  </Input>
                </FormItem>
              </Col>
              <!-- 复合类型  select + datepicker -->
              <Col
                v-bind="JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }"
                v-if="item.type === 9"
              >
                <FormItem
                  class="formItem reunite reunitePicker"
                  :prop="'data.' + idx + '.value'"
                  :rules="item.rules"
                >
                  <!-- background-color: aliceblue; -->
                  <Select
                    v-model="item.value[0]"
                    :style="item.width ? 'width:' + item.width : 'width: 100px'"
                    @on-change="(item.value[1] = ''), item.change(item)"
                    :transfer="true"
                    class="selectStyle"
                  >
                    <Option
                      v-for="v in item.arr"
                      :value="v.value"
                      :key="v.value"
                      :label="v.label"
                      >{{ v.label }}</Option
                    >
                  </Select>

                  <DatePicker
                    clearable
                    :transfer="true"
                    :type="item.dateType ? item.dateType : 'date'"
                    v-model="item.value[1]"
                    @on-change="(val) => timeChange(val, item)"
                    :format="!item.dateType ? 'yyyy-MM-dd' : null"
                    placeholder="请选择时间"
                  ></DatePicker>
                </FormItem>
              </Col>
              <!-- 复合类型  select + select -->
              <Col
                v-bind="JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }"
                v-if="item.type === 12"
              >
                <FormItem
                  :label="item.name + ''"
                  class="formItem reunite reunitePicker"
                  :prop="'data.' + idx + '.value'"
                  :rules="item.rules"
                >
                  <Select
                    v-model="item.value[0]"
                    style="width: 80px"
                    class="other_fir"
                    @on-change="otherChange(item)"
                    :transfer="true"
                    clearable
                  >
                    <Option
                      v-for="v in item.arr1"
                      :value="v.value"
                      :key="v.value"
                      :label="v.label"
                      >{{ v.label }}</Option
                    >
                  </Select>
                  <Select
                    style="background: #fff"
                    class="other"
                    v-model="item.value[1]"
                    :transfer="true"
                    clearable
                  >
                    <Option
                      v-for="v in item.arr2"
                      :value="v.value"
                      :key="v.value"
                      :label="v.label"
                      >{{ v.label }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <!-- switch  type = 10-->
              <Col
                v-bind="JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }"
                v-if="item.type === 10"
              >
                <FormItem
                  :label="item.name + ''"
                  class="formItem"
                  :prop="'data.' + idx + '.value'"
                  :rules="item.rules"
                >
                  <i-switch
                    :true-value="
                      item.trueValue !== undefined ? item.trueValue : true
                    "
                    :false-value="
                      item.falseValue !== undefined ? item.falseValue : false
                    "
                    v-model="item.value"
                    @on-change="
                      (value) => (item.fn ? item.fn(value, item) : () => {})
                    "
                  />
                </FormItem>
              </Col>
              <!-- 级联  type = 11-->
              <Col
                v-bind="JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }"
                v-if="item.type === 11"
              >
                <FormItem
                  :label="item.name + ''"
                  class="formItem"
                  :prop="'data.' + idx + '.value'"
                  :rules="item.rules"
                >
                  <Cascader
                    :transfer="true"
                    :data="item.arr"
                    v-model="item.value"
                    @on-change="
                      (value) => (item.fn ? item.fn(value, item) : () => {})
                    "
                  ></Cascader>
                </FormItem>
              </Col>
              <!-- <Col
                v-bind="JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }"
                v-if="item.type === 'search'"
              >
                <slot></slot>
              </Col>-->
            </template>
          </Row>
          <!-- 动态表单  遍历每一项的data，数组结构为多个表单项-->
          <Row type="flex" justify="start" v-if="item1.add">
            <!-- 外层控制表单个数 -->
            <template v-for="(item2, idx0) in item1.data">
              <!-- 动态表单删除按钮 -->
              <div
                style="width: 100%"
                class="line removeBox"
                v-if="item1.add && item1.data.length > 0"
              >
                <Icon
                  class="pointer"
                  type="md-trash"
                  size="24"
                  @click="removeFormList(item1, item2, idx0)"
                />
              </div>
              <!-- 内层空表表单具体内容 -->
              <template v-for="(item, idx) in item2.data">
                <!-- 输入框 -->
                <Col
                  v-bind="
                    JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }
                  "
                  v-if="item.type === 1"
                >
                  <FormItem
                    :label="item.name"
                    class="formItem"
                    :prop="'data.' + idx0 + '.data.' + idx + '.value'"
                    :rules="item.rules"
                  >
                    <Input
                      width="100%"
                      :placeholder="`请输入${item.name}`"
                      v-model.trim="item.value"
                      :type="item.modelType ? item.modelType : 'text'"
                      @on-change="(val) => onChange(val, item)"
                    ></Input>
                  </FormItem>
                </Col>
                <!--下拉框 -->
                <Col v-if="item.type === 2" :key="idx">
                  <FormItem
                    :label="item.name"
                    class="formItem"
                    :prop="'data.' + idx0 + '.data.' + idx + '.value'"
                    :rules="item.rules"
                  >
                    <Select
                      width="100%"
                      :multiple="item.multiple ? true : false"
                      v-model="item.value"
                      :placeholder="`请输入${item.name}`"
                      filterable
                      @on-query-change="
                        (e) => {
                          item.remote ? item.queryChange(e, item) : () => {};
                        }
                      "
                      :remote-method="
                        item.remote
                          ? (name) => item.remoteMethod(name, item)
                          : () => {}
                      "
                      :remote="item.remote ? true : false"
                      @on-change="
                        (value) => (item.fn ? item.fn(value, item) : () => {})
                      "
                    >
                      <Option
                        v-for="v in item.arr"
                        :value="v.value"
                        :key="v.value"
                        :label="v.label"
                      >
                        <!-- {{ v.label }} -->
                        <node-content :current="v" :data="item" />
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
                <!-- 日期选择 -->
                <Col
                  v-bind="
                    JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }
                  "
                  v-if="item.type === 3"
                >
                  <FormItem
                    :label="item.name"
                    class="formItem"
                    :prop="'data.' + idx0 + '.data.' + idx + '.value'"
                    :rules="item.rules"
                  >
                    <DatePicker
                      :transfer="true"
                      :type="item.dateType ? item.dateType : 'date'"
                      width="100%"
                      :value="item.value"
                      format="yyyy-MM-dd"
                      :placeholder="`请选择${item.name}`"
                      @on-change="(val) => changeTime(val, item)"
                      @on-open-change="
                        (val) =>
                          item.onOpenChange
                            ? item.onOpenChange(val, item)
                            : null
                      "
                    ></DatePicker>
                  </FormItem>
                </Col>
                <!-- 树形结构 -->
                <Col
                  v-bind="
                    JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }
                  "
                  v-if="item.type === 4"
                >
                  <FormItem
                    :label="item.name"
                    class="formItem selectTree"
                    :prop="'data.' + idx0 + '.data.' + idx + '.value'"
                    :rules="item.rules"
                  >
                    <selectTree
                      :data="item.arr"
                      :multiple="false"
                      :size="null"
                      :placeholder="`请选择${item.name}`"
                      v-model="item.value"
                      :clearable="item.clearable ? true : false"
                      :selectAllChildren="
                        item.selectAllChildren ? item.selectAllChildren : false
                      "
                      @onChange="
                        item.inputChange
                          ? (value) => inputChange(item, value)
                          : () => {}
                      "
                    ></selectTree>
                  </FormItem>
                </Col>
                <!--数字类型 -->
                <Col
                  v-bind="
                    JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }
                  "
                  v-if="item.type === 5"
                >
                  <FormItem
                    :label="item.name"
                    class="formItem"
                    :prop="'data.' + idx0 + '.data.' + idx + '.value'"
                    :rules="item.rules"
                  >
                    <InputNumber
                      width="100%"
                      :placeholder="`请输入${item.name}`"
                      v-model.trim="item.value"
                    ></InputNumber>
                  </FormItem>
                </Col>
                <!--单选radio -->
                <Col
                  v-bind="
                    JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }
                  "
                  v-if="item.type === 6"
                >
                  <FormItem
                    :label="item.name"
                    class="formItem"
                    :prop="'data.' + idx0 + '.data.' + idx + '.value'"
                    :rules="item.rules"
                  >
                    <RadioGroup
                      v-model="item.value"
                      @on-change="
                        item.radioChange
                          ? item.radioChange(item.value)
                          : () => {}
                      "
                    >
                      <Radio
                        :style="{
                          marginRight: i !== item.arr.length - 1 ? '40px' : 0,
                        }"
                        :key="i"
                        :label="v.value"
                        v-for="(v, i) in item.arr"
                        >{{ v.label }}</Radio
                      >
                    </RadioGroup>
                  </FormItem>
                </Col>
                <!--多选checkBox -->
                <Col
                  v-bind="
                    JSON.stringify($attrs) !== '{}' ? $attrs : { span: 24 }
                  "
                  v-if="item.type === 7"
                >
                  <FormItem
                    :label="item.name"
                    class="formItem"
                    :prop="'data.' + idx0 + '.data.' + idx + '.value'"
                    :rules="item.rules"
                  >
                    <CheckboxGroup v-model="item.value">
                      <Checkbox
                        :style="{
                          marginRight: i !== item.arr.length - 1 ? '40px' : 0,
                        }"
                        :key="i"
                        :label="v.value"
                        v-for="(v, i) in item.arr"
                        >{{ v.label }}</Checkbox
                      >
                    </CheckboxGroup>
                  </FormItem>
                </Col>
              </template>
            </template>
            <!-- 动态添加表单 -->
            <div v-if="item1.add" style="width: 100%">
              <div
                class="addBox"
                v-if="item1.add && item1.add.show"
                @click="() => item1.addMethod(item1.data)"
              >
                <span>
                  <Icon type="md-add" />
                  {{ item1.add.text }}
                </span>
              </div>
            </div>
          </Row>
          <slot></slot>
        </div>
      </Form>
      <!-- <div class="footer" v-if="$slots.default">
        <Button type="primary" @click="submitForm">确定</Button>
        <Button @click="cancelForm">取消</Button>
      </div>-->
      <!-- 插槽占位 -->
    </div>
  </div>
</template>

<script>
import selectTree from "@/components/commons/selectTree";
import filters from "@/api/filter";
export default {
  name: "column",
  props: ["formList"],
  data() {
    return {
      formDate: [],
    };
  },
  mounted() {
    this.dealFormDate();
  },
  watch: {
    formList: {
      handler(newVal) {
        this.dealFormDate();
      },
      deep: true,
    },
  },
  components: {
    selectTree,
    NodeContent: {
      props: {
        data: {
          //用户配置的下拉的完整参数 {...}
          required: true,
        },
        current: {
          //当前下拉选项  label value
          required: true,
        },
      },
      render(h) {
        const node = this.node;
        console.log(this.data);
        return this.data.render ? (
          this.data.render(h, this.current)
        ) : (
          <div>{this.current.label}</div>
        );
      },
    },
    customeRender: {
      props: {
        value: {
          default: "",
        },
        render: {
          type: Function,
        },
        current: {
          default: "",
        },
      },
      render(h) {
        // console.log(vm.outerData);
        return this.render
          ? this.render(h, this.current)
          : this.$scopedSlots &&
              this.$scopedSlots.default &&
              this.$scopedSlots.default();
      },
    },
  },
  methods: {
    dealTime(time, filter = "YYYY-MM-DD") {
      if (filter === "none") return time;
      const value = filters.filterTime(time, filter);
      return value;
    },
    dealValue(value, arr) {
      const item = arr.find((item) => item.value == value);
      if (item) {
        return item.label;
      }
    },
    // change(){alert('111')},
    timeChange(val, item) {
      if (val != "") {
        item.value[1] = val;
      }
    },
    //对用户传入的form数据类型处理
    dealFormDate() {
      const type = this.formList.every((item) => {
        return item.data instanceof Array;
      });
      if (!type) {
        //用户传入的单表单配置
        this.formDate = [{ data: this.formList }];
      } else {
        this.formDate = this.formList;
      }
      // if (!this.formDate[0].data.find(item => item.type === "search")) {
      //   this.formDate[0].data.push({
      //     type: "search"
      //   });
      // }
    },
    submitForm() {
      this.clearSearchList();
      this.validate((valid, obj) => {
        this.$emit("submit", obj);
      });
    },
    clearSearchList() {
      for (let i = 0; i < this.$refs[`filterableSearchName`].length; i++) {
        let query = this.$refs[`filterableSearchName`][i].$data.query;
        if (query) {
          this.$refs[`filterableSearchName`][i].$data.query = "";
        }
      }
    },
    otherChange(item) {
      item.value[1] = "";
      item.change ? item.change(item) : null;
    },
    cancelForm() {
      this.resetFields();
    },
    changeTime(val, item) {
      item.value = val;
    },
    removeFormList(item1, item2, index) {
      item1.add.show = true;
      item1.data.splice(index, 1);
    },
    validate(fn) {
      //多表单验证
      const res = this.dealValidForm();
      if (res.length === this.formDate.length) {
        //格式化返回表单数据   [{...,data:[key,value]},{...,data:[{data:[key,value]}]},{}]
        let obj = {};
        this.formDate.forEach((formItem, index) => {
          if (formItem.add) {
            if (formItem.data.length > 0) {
              obj["form" + index] = [];
              //动态添加的表单 data:[{data:[key,value]}]
              formItem.data.forEach((item, idx) => {
                if (item.data.length > 0) {
                  obj["form" + index][idx] = {};
                  item.data.forEach((item2) => {
                    if (
                      this.checkHasValue(item2.value, item2.type, item.notCheck)
                    ) {
                      obj["form" + index][idx][item2.key] = item2.value;
                    }
                  });
                  if (JSON.stringify(obj["form" + index][idx]) === "{}") {
                    delete obj["form" + index];
                  }
                }
              });
            }
          } else {
            obj["form" + index] = {};
            //正常遍历的表单   data:[key,value]
            formItem.data.forEach((item) => {
              if (this.checkHasValue(item.value, item.type, item.notCheck)) {
                if (!(item.key instanceof Array)) {
                  obj["form" + index][item.key] = item.value;
                } else {
                  //复合类型
                  item.key.forEach((its, idx) => {
                    obj["form" + index][its] = item.value[idx];
                  });
                }
              }
            });
          }
        });
        // console.log(Object.keys(obj));
        if (Object.keys(obj).length === 1) {
          obj = obj.form0;
        }

        console.log(obj);
        fn(true, obj);
      } else {
        fn(false);
      }
    },
    //校验是否有值
    checkHasValue(value, type, notCheck) {
      if (type == 11 || type == 10 || notCheck) return true;
      if (value instanceof Array) {
        if (value.length === 0) {
          return false;
        } else {
          //复合类型必须两个都有值
          for (let item of value) {
            if (item instanceof Array) {
              return this.checkHasValue(item);
            } else {
              if (!item) {
                return false;
              }
            }
          }
        }
      } else {
        if (!value) {
          return false;
        }
      }
      return true;
    },
    resetFields() {
      this.formDate.forEach((item, idx) => {
        //多表单重置
        this.$refs[`perForm${idx}`][0].resetFields();
      });
      // this.clearSearchList();
    },
    dealValidForm() {
      let arr = [];
      this.formDate.forEach((item, idx) => {
        this.$refs[`perForm${idx}`][0].validate((valid, object) => {
          if (valid) {
            arr.push(true);
          } else {
            //滚动到错误的位置
            this.$nextTick(() => {
              var el = document.querySelector(".ivu-form-item-error");
              window.scroll({ top: el.offsetTop, behavior: "smooth" });
              // document.querySelector(".ivu-form-item-error").scrollIntoView({
              //   //滚动到指定节点
              //   block: "center", //值有start,center,end，nearest，当前显示在视图区域中间
              //   behavior: "smooth" //值有auto、instant,smooth，缓动动画（当前是慢速的）
              // });
            });
          }
        });
      });
      return arr;
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .block {
  display: block !important;
  width: 100% !important;
}
/deep/ .ivu-form .ivu-form-item-label {
  text-align: right !important;
}
/deep/ .notShow {
  opacity: 0 !important;
}
/deep/ .treeSelect .wrap {
  z-index: 1000000;
  top: 40px;
  .ivu-input-wrapper {
    margin: 10px 0;
  }
}
/deep/ .other_fir {
  border-right: 1px solid #dcdee2;
  .ivu-select-selection {
    background-color: #f8f8f9 !important;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}
/deep/ .other {
  .ivu-select-selection {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    margin-left: -1px;
    border-left: 0;
    > div {
      background: #fff;
    }
  }
}
.formGroup {
  /deep/ .reunite .ivu-form-item-content {
    margin-left: 0 !important;
    display: flex;
  }
  /deep/ .reunitePicker .ivu-date-picker {
    // width: 69%;
    flex: 1;
    .ivu-input {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
  /deep/ .reunitePicker .ivu-date-picker-rel input {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

    margin-left: -1px;
  }
  /deep/ .reunitePicker .ivu-form-item-content {
    .ivu-select-selection-focused,
    .ivu-select-selection:hover {
      border-color: #dcdee2;
      outline: none;
    }
    .ivu-select-selected-value {
      border-right: 0;
    }
    /deep/ .ivu-select-selection {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: 0;
      box-shadow: none;
      outline: none;
      background-color: #f8f8f9 !important;
    }

    /deep/ .ivu-date-picker-rel {
      border-radius: 0;
    }

    /deep/ .other .ivu-select-selection {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      background: #fff;
      border-right: 1px solid #dcdee2;
      border-left: none;
    }

    // overflow: hidden;
    > div {
      float: left;
      .ivu-select-selected-value {
        // background: #f8f8f9;
      }
    }
  }
  padding: 14px;
  /deep/ .ivu-date-picker {
    display: block;
    width: 100%;
  }
  /deep/ .ivu-input-number {
    width: 100%;
  }
  .footer {
    text-align: center;
    button:nth-child(1) {
      margin-right: 20px;
    }
  }
  .addBox {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin-bottom: 30px;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.02);
    border: 1px dashed rgba(0, 0, 0, 0.15);
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
  }
  .removeBox {
    text-align: right;
    border-bottom: 1px solid #ededed;
    padding-bottom: 20px;
    margin-bottom: 40px;
  }
  .pointer {
    &:hover {
      cursor: pointer;
    }
  }
  /deep/ .ivu-form-item-content {
    // #272933;
    color: #515a6e;
  }
  /deep/ .ivu-input,
  .ivu-select {
    color: #272933;
    font-size: 13px;
  }
  /deep/ .ivu-form-item-label {
    font-size: 13px;
  }
}
</style>
